var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRightArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 109,
    viewBox: "0 0 114 109",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 26.9378L53.668 13.1605L88.983 22.2639L79.8831 57.5735L71.6558 43.6351C46.6507 61.0487 33.556 87.1565 38.8465 107.86C36.4698 105.626 34.4068 103.078 32.7215 100.223C19.9804 78.6368 32.974 47.0109 61.8001 26.9378Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/right_arrow.4ec04d42.svg";
export { ForwardRef as ReactComponent };